import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CustomSwitch,
  DescriptionPrice,
  StackStyled,
} from "./PrincingToggle.style";
import PrincingComparaison from "@components/Home/PrincingComparaison/PrincingComparaison";

export default function Pricing() {
  const [billing, setBilling] = useState("monthly");
  const { t } = useTranslation();

  const isMonthly = billing === "monthly";

  return (
    <StackStyled
      spacing={2}
      alignItems="center"
      className="princing col-lg-7 col-md-6 col-sm-12">
      <Typography variant="h2" width={"100%"}>
        {t("home.simple_pricing_1")}
      </Typography>
      <Typography variant="h2" width={"100%"}>
        {t("home.simple_pricing_2")}
      </Typography>
      <DescriptionPrice>{t("home.simple_pricing_desc")}</DescriptionPrice>

      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        gap={1}
        width={"100%"}
        sx={{
          margin: "2rem 0 !important",
        }}>
        <Typography fontWeight={isMonthly ? "bold" : "normal"} color="#181059">
          {t("home.bill_monthly")}
        </Typography>
        <CustomSwitch
          checked={billing === "annually"}
          onChange={(e) =>
            setBilling(e.target.checked ? "annually" : "monthly")
          }
        />
        <Typography fontWeight={!isMonthly ? "bold" : "normal"} color="#181059">
          {t("home.bill_annualy")}
        </Typography>
      </Stack>
      <PrincingComparaison />
    </StackStyled>
  );
}
